/** First beat after the stream looks idle to the user (heartbeats still flow). */
export const LIVE_WAIT_STILL_MS = 12_000
/** Escalate: this is taking longer than a typical tool turn. */
export const LIVE_WAIT_LONG_MS = 30_000
/** Escalate again. Cause is unknown here (a read, a slow model, or a large write). */
export const LIVE_WAIT_VERY_LONG_MS = 60_000

export function formatWaitClock(elapsedMs: number): string {
  const sec = Math.max(0, Math.floor(elapsedMs / 1000))
  const minutes = Math.floor(sec / 60)
  const seconds = sec % 60
  return `${minutes}:${String(seconds).padStart(2, '0')}`
}

/** Status under live thinking chrome. Null until the first beat. */
export function liveWaitStatusCopy(elapsedMs: number): string | null {
  if (elapsedMs < LIVE_WAIT_STILL_MS) return null
  if (elapsedMs < LIVE_WAIT_LONG_MS) return 'Still working...'
  if (elapsedMs < LIVE_WAIT_VERY_LONG_MS) {
    return 'Taking longer than usual.'
  }
  return 'Still going.'
}
